import { Action } from 'redux';
import { SearchFilterValues } from '../../logic/domains/searchFilters.domain';

export enum SearchFilterActionTypes {
	SEARCH_APPLY_FILTERS = '@@search/SEARCH_APPLY_FILTERS',
	CLEAR_SEARCH_FILTERS = '@@search/CLEAR_SEARCH_FILTERS',
}

export interface SearchApplyFiltersAction extends Action {
	readonly type: SearchFilterActionTypes.SEARCH_APPLY_FILTERS;
	searchKeyword?: string;
	searchFilters?: SearchFilterValues;
}

export interface ClearSearchFiltersAction extends Action {
	readonly type: SearchFilterActionTypes.CLEAR_SEARCH_FILTERS;
}

export function searchFilterAction(
	searchKeyword?: string,
	searchFilters?: SearchFilterValues
): SearchFilterActions {
	return {
		type: SearchFilterActionTypes.SEARCH_APPLY_FILTERS,
		searchKeyword,
		searchFilters,
	};
}

export function clearSearchFiltersAction(): SearchFilterActions {
	return {
		type: SearchFilterActionTypes.CLEAR_SEARCH_FILTERS,
	};
}

export type SearchFilterActions =
	| SearchApplyFiltersAction
	| ClearSearchFiltersAction;
